import { sessionIdKey } from "utils/constants";

const { v4: uuidv4 } = require("uuid");

export const getSessionId = () => {
    if (typeof window === "undefined") return null;

    try {
        let sessionId = window.sessionStorage.getItem(sessionIdKey);

        if (!sessionId) {
            sessionId = uuidv4();
            window.sessionStorage.setItem(sessionIdKey, sessionId);
        }

        return sessionId;
    } catch (error) {
        console.error("Unable to read or persist session id:", error);
        return null;
    }
};

export default getSessionId;
